var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThingArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99993 5.25628C2.65823 5.59799 2.65822 6.15201 2.99993 6.49372L7.99993 11.4937L12.9999 6.49372C13.3416 6.15201 13.3416 5.59799 12.9999 5.25628C12.6582 4.91457 12.1042 4.91457 11.7625 5.25628L7.99993 9.01885L4.23737 5.25628C3.89566 4.91457 3.34164 4.91457 2.99993 5.25628Z",
    fill: "#8082C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThingArrowDown);
export default __webpack_public_path__ + "static/media/thingArrowDown.09dece4088eed69bdbf662d45c4c3188.svg";
export { ForwardRef as ReactComponent };